import { format, isValid, parseISO } from 'date-fns';

/** `yyyy-MM-dd` for inputs and API — strips time from ISO strings. */
export function toDateOnlyString(value: Date | string | null | undefined): string {
  if (value == null || value === '') return '';
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? '' : format(value, 'yyyy-MM-dd');
  }
  const s = String(value).trim();
  if (!s) return '';
  if (s.includes('T')) return s.slice(0, 10);
  return s.length >= 10 ? s.slice(0, 10) : s;
}

/** Date-only label for tables and modals (no time). */
export function formatDisplayDate(value: Date | string | null | undefined): string {
  const dateOnly = toDateOnlyString(value);
  if (!dateOnly) return '—';
  const d = parseISO(`${dateOnly}T00:00:00`);
  if (!isValid(d)) return dateOnly;
  return d.toLocaleDateString('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}
